module.exports = __webpack_public_path__ + "img/Report.acf8e39a.svg";